exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__modalHeader___ZzA6s{font-family:PlayfairDisplay-Regular;font-size:32px;font-weight:300;margin:0}.style__modalHeader___ZzA6s sup{position:relative;top:8px}.style__headerDetails___ApXba{font-family:PlayfairDisplay-Regular;font-style:italic;font-size:18px;margin:12px 0}.style__price___291P9{color:#c1887f;font-size:18px;text-align:left}.style__hr___1DSPk{margin:20px 0}.style__add___3snSv{margin-top:40px}.style__add___3snSv *{margin:0 auto;display:block}.style__paginationButton___1xU_p{top:50%;position:absolute;border:0;background:0;box-shadow:none;font-size:24px}.style__paginationButton___1xU_p:hover{cursor:pointer}", ""]);

// exports
exports.locals = {
	"modalHeader": "style__modalHeader___ZzA6s",
	"headerDetails": "style__headerDetails___ApXba",
	"price": "style__price___291P9",
	"hr": "style__hr___1DSPk",
	"add": "style__add___3snSv",
	"paginationButton": "style__paginationButton___1xU_p"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/diamond-modal/style.css
// module id = 675
// module chunks = 0